export default __webpack_public_path__ + "static/media/sa-icon.176a74d8.webp";